import { createAction, props } from '@ngrx/store'
import { CustomerPaymentMethodsEntity } from './customer-payment-methods.models'
import { HttpErrorResponse } from '@angular/common/http'

export const loadCustomerPaymentMethods = createAction(
  '[CustomerPaymentMethods Page] Load CustomerPaymentMethods',
  props<{ setCardSelected?: boolean }>(),
)

export const loadCustomerPaymentMethodsSuccess = createAction(
  '[CustomerPaymentMethods/API] Load CustomerPaymentMethods Success',
  props<{ customerPaymentMethods: CustomerPaymentMethodsEntity[] }>(),
)

export const loadCustomerPaymentMethodsFailure = createAction(
  '[CustomerPaymentMethods/API] Load CustomerPaymentMethods Failure',
  props<{ error: HttpErrorResponse }>(),
)

export const setSelectedCustomerPaymentMethod = createAction(
  '[PaymentMethods/API] Set Selected CustomerPaymentMethod',
  props<{ paymentMethodId: string }>(),
)

export const clearSelectedCustomerPaymentMethod = createAction(
  '[PaymentMethods/API] Clear Selected CustomerPaymentMethod',
)

export const clearCustomerPaymentMethods = createAction('[PaymentMethods] Clear CustomerPaymentMethods')
